export default __webpack_public_path__ + "static/media/triangles.13c3f04c518f9d2aa51ac9ec56d3d327.svg";